/**
 * Télémétrie fournie par l'app hôte.
 *
 * `libs/shared/core` est compilée dans des apps web ET natives : elle ne peut pas
 * importer un SDK en dur. Elle importait `@sentry/react` et `@amplitude/*` côté
 * navigateur, ce qui, dans passenger-app, faisait cohabiter deux `@sentry/core`
 * (v8 via @sentry/react, v10 via @sentry/react-native). Sentry range son client
 * sur un carrier global versionné : les deux ne se voyaient pas et TOUTES les
 * erreurs remontées depuis le code partagé étaient silencieusement perdues sur
 * mobile.
 *
 * Chaque app branche donc son propre SDK ici. Champ requis volontairement : le
 * typecheck refuse de compiler une app qui l'oublierait.
 */
export interface Telemetry {
  captureException: (
    error: unknown,
    context?: { tags?: Record<string, string>; extra?: Record<string, unknown> },
  ) => void;
  setUser: (userId: string, traits?: Record<string, string>) => void;
  resetUser: () => void;
}

export interface LibConfig {
  telemetry: Telemetry;
  isProd: boolean;
  passengerApiUrl?: string;
  remoteConfigUrl?: string;
  driverApiUrl?: string;
  boApiUrl?: string;
  storagePrefix: string | null;
  systemLocale: string | null;
  forceLocale?: string | null;
  preludeApiKey?: string;
  reloadSystem: () => void;
  googleClientIdIos?: string;
  googleWebClientId?: string;
  openWebUrl?: (url: string) => void;
  storage: {
    setItem: (_key: string, _value: string) => void;
    getItem: (_key: string) => string | null | undefined;
    removeItem: (_key: string) => void;
  };
}

let _config: LibConfig | null = null;

export const initSharedLib = (config: LibConfig) => {
  _config = config;
};

export const getConfig = (): LibConfig => {
  if (!_config) {
    throw new Error('Shared library non initialisée. Appelez initSharedLib() au démarrage.');
  }
  return _config;
};
